import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import SearchResults from './SearchResults';
import UsedCarsLanding from './UsedCarsLanding';
import CarDetail from './CarDetail';
import './styles.css';
import Header from './Components/Header';
import Footer from './Footer';
import TermsOfUse from './Pages/TermsOfUse';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import About from './Pages/About';
import RegisterForm from './UserLogin/RegisterForm';
import LoginForm from './UserLogin/LoginForm';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './AuthContext';
import DealerInventory from './DealerInventory';
import SavedCars from './SavedCars.js';
import SavedSearches from './SavedSearches.js';
import CheckEmailPage from './UserLogin/CheckEmailPage';
import EmailVerificationResult from './UserLogin/EmailVerificationResult';
import ForgotPasswordPage from './UserLogin/ForgotPasswordPage';
import ResetPasswordPage from './UserLogin/ResetPasswordPage';
import Join from './Components/Join';
import DealerLeads from "./Dealer/Leads";
import DealerLogin from "./Dealer/Login";
import RequireDealerAuth from "./Dealer/RequireDealerAuth";
import RedeemInvite from "./Dealer/RedeemInvite";
import DealerInvitesPage from "./Dealer/DealerInvitesPage";
import DealerLeadDetail from './Dealer/DealerLeadDetail';
import PublicChat from "./PublicChat";    
import RequireDealer from "./Dealer/RequireDealer.jsx";
import InviteDealer from "./Staff/InviteDealer";
import StaffLogin from "./Staff/StaffLogin";
import StaffHome from "./Staff/StaffHome";
import StaffGuard from "./Staff/StaffGuard";
import ManageStaff from "./Staff/ManageStaff";
import DealerContactReview from "./Staff/DealerContactReview";
import DealerStaff from "./Dealer/DealerStaff";
import ForgotPasswordDealer from "./Dealer/ForgotPasswordDealer";
import DealerResetPassword from "./Dealer/DealerResetPassword";
import DealerChangePassword from "./Dealer/DealerChangePassword";
import DealerProfile from "./Dealer/DealerProfile";
import DealerDashboard from "./Dealer/DealerDashboard";
import DealerSettings from "./Dealer/DealerSettings";
import DealerInventoryPortal from "./Dealer/DealerInventoryPortal";
import DealerInventoryEdit from "./Dealer/DealerInventoryEdit";
import FeedbackWidget from "./Components/FeedbackWidget";
import BlogIndex from "./Blog/BlogIndex";
import BlogArticle from "./Blog/BlogArticle";
import InsightsBestDeals from "./InsightsBestDeals";
import BestDealsMarketPage from "./BestDealsMarketPage";
import Research from "./Pages/Research";
import MiamiUsedCarMarketAugust2026 from "./Research/MiamiUsedCarMarketAugust2026";
import DealChecker from "./DealChecker";
import DealerAppraisal from "./Dealer/DealerAppraisal";
import AnalyticsPageView from './Components/AnalyticsPageView';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsPageView />
        <ToastContainer position="top-center" autoClose={3000} />
        <Header/>
        <Routes>
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/deal-checker" element={<DealChecker />} />
          <Route path="/used-cars/:make/:model" element={<UsedCarsLanding />} />
          <Route path="/car/:id/:slug" element={<CarDetail />} />
          <Route path="/car/:id" element={<CarDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/dealer/:dealerId" element={<DealerInventory />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/about" element={<About />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/miami-used-car-market-august-2026" element={<MiamiUsedCarMarketAugust2026 />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/insights" element={<Navigate to="/insights/best-deals" replace />} />
          <Route path="/insights/best-deals" element={<InsightsBestDeals />} />
          <Route path="/used-cars/:marketSlug/best-deals" element={<BestDealsMarketPage />} />
          <Route path="/saved" element={<SavedCars />} />
          <Route path="/savedsearches" element={<SavedSearches />} />
          <Route path="/check-email" element={<CheckEmailPage />} />
          <Route path="/verify-email" element={<EmailVerificationResult />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/join" element={<Join />} />
          <Route path="/dealer/redeem" element={<RedeemInvite />} />
          <Route path="/dealer/join/:code" element={<RedeemInvite />} />
          <Route path="/chat/:token" element={<PublicChat />} />
          <Route path="/lead/:token" element={<PublicChat />} />
          <Route path="/dealer/inventory" element={<DealerInventoryPortal />} />
          <Route path="/dealer/account/profile" element={<DealerProfile />} />
          <Route path="/dealer/dashboard" element={<DealerDashboard />} />
          <Route
            path="/dealer/appraisal"
            element={
              <RequireDealerAuth>
                <DealerAppraisal />
              </RequireDealerAuth>
            }
          />
          <Route path="/dealer/settings" element={<DealerSettings />} />
          <Route
            path="/dealer/leads"
            element={
              <RequireDealerAuth>
                <DealerLeads />
              </RequireDealerAuth>
            }
          />

          <Route
            path="/dealer/leads/:id"
            element={
              <RequireDealerAuth>
                <DealerLeadDetail />
              </RequireDealerAuth>
            }
          />

         <Route
  path="/dealer/invites"
  element={
    <RequireDealer roles={["DealerAdmin", "DealerManager"]}>
      <DealerInvitesPage />
    </RequireDealer>
  }
/>

          <Route path="/dealer/login" element={<DealerLogin />} />
          <Route path="/dealer/staff" element={<DealerStaff />} />
          <Route path="/dealer/inventory/:id/edit" element={<DealerInventoryEdit />} />
          <Route path="/dealer/account/password" element={<DealerChangePassword />} />
          <Route path="/dealer/forgot-password" element={<ForgotPasswordDealer />} />
          <Route path="/dealer/reset-password" element={<DealerResetPassword />} />
          <Route
            path="/staff/manage-staff"
            element={
              <StaffGuard>
                <ManageStaff />
              </StaffGuard>
            }
          />
          <Route
            path="/staff/invite-dealer"
            element={
              <StaffGuard>
                <InviteDealer />
              </StaffGuard>
            }
          />
          <Route
            path="/staff/dealers/contact-review"
            element={
              <StaffGuard>
                <DealerContactReview />
              </StaffGuard>
            }
          />
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route
            path="/staff"
            element={
              <StaffGuard>
                <StaffHome />
              </StaffGuard>
            }
          />
          <Route
            path="/staff/invites"
            element={
              <StaffGuard>
                {/* <StaffInvites /> */}
                <StaffHome /> {/* temp, if StaffInvites not built yet */}
              </StaffGuard>
            }
          />
          {/* Catch-all 404 route */}
          <Route path="*" element={<h2 style={{ textAlign: "center", marginTop: "50px" }}>404 - Page Not Found</h2>} />
        </Routes>
        <FeedbackWidget />
        <Footer/>
      </Router>
    </AuthProvider>
  );
}

export default App;
